import axios from 'axios';
import { getToken } from '@/common/jwt.service';

// const baseURL = process.env.VUE_APP_BASE_URL || 'http://80.78.246.116:9988/api';
const baseURL = process.env.VUE_APP_BASE_URL || 'https://dev.sostaff.app/api';
const instance = axios.create({ baseURL, timeout: 25000 });

instance.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = 'ru';
  const token = getToken();
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

instance.interceptors.response.use(
  (resp) => resp.data,
  (err) => {
    if (err.response?.status >= 500) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        data: {
          server: [`Ошибка статус ${err.response.status}`],
        },
        status: err.response.status

      });
    }
    if (err.response) {
      return Promise.reject(err.response);
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      data: { not_server_response: ['Ошибка соединения с сервером'] }, status: null
    });
  },
);

export default instance;
